// extracted by mini-css-extract-plugin
module.exports = {"usercard":"MemberCard_usercard__329um"};